import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLang } from '@/i18n/LanguageContext';
import { Container, NGRPLogoMark, TricolourRibbon } from '@/components/common/Layout';

export function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="mt-16 border-t border-[#D7E1EF] bg-white"
    >
      <TricolourRibbon />
      <Container className="py-12">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-3">
              <NGRPLogoMark size={44} />
              <div>
                <div className="font-display font-semibold text-[#062B5C]">
                  {t('common.party_name_full')}
                </div>
                <div className="text-xs text-[#5B6B82] font-medium">
                  {t('common.party_short')} · {t('footer.motto')}
                </div>
              </div>
            </div>
            <p className="mt-4 text-sm text-[#5B6B82] leading-relaxed max-w-md">
              {t('common.supporting_line')}
            </p>
            <p className="mt-3 text-xs text-[#5B6B82]">{t('common.tagline')}</p>
          </div>

          <FooterColumn title={t('footer.about_col')}>
            <FooterLink to="/about">{t('footer.about_link')}</FooterLink>
            <FooterLink to="/national">{t('nav.national')}</FooterLink>
            <FooterLink to="/vision">{t('nav.vision')}</FooterLink>
            <FooterLink to="/emblem">{t('nav.emblem')}</FooterLink>
            <FooterLink to="/constitution">{t('nav.constitution')}</FooterLink>
            <FooterLink to="/agenda">{t('footer.agenda_col')}</FooterLink>
          </FooterColumn>

          <FooterColumn title={t('footer.resources_col')}>
            <FooterLink to="/manifesto">{t('footer.resources_manifesto')}</FooterLink>
            <FooterLink to="/roadmap">{t('nav.roadmap')}</FooterLink>
            <FooterLink to="/dashboard">{t('footer.resources_dashboard')}</FooterLink>
            <FooterLink to="/news">{t('footer.resources_news')}</FooterLink>
          </FooterColumn>

          <FooterColumn title={t('footer.participate_col')}>
            <FooterLink to="/dialogue">{t('nav.dialogue')}</FooterLink>
            <FooterLink to="/join">{t('footer.participate_join')}</FooterLink>
            <FooterLink to="/aspirant">{t('footer.participate_apply')}</FooterLink>
            <FooterLink to="/contact">{t('footer.participate_contact')}</FooterLink>
          </FooterColumn>
        </div>

        <div className="mt-10 pt-6 border-t border-[#D7E1EF] flex flex-col md:flex-row gap-3 items-start md:items-center justify-between">
          <div className="text-xs text-[#5B6B82]">{t('footer.copyright')}</div>
          <div className="flex items-center gap-5 text-xs text-[#5B6B82]">
            <NavLink to="/transparency" className="hover:text-[#062B5C]">
              {t('footer.accountability_transparency')}
            </NavLink>
            <NavLink to="/admin" className="hover:text-[#062B5C]">
              {t('footer.accountability_admin')}
            </NavLink>
            <span>{t('footer.privacy')}</span>
            <span>{t('footer.terms')}</span>
          </div>
        </div>
      </Container>
    </footer>
  );
}

function FooterColumn({ title, children }) {
  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[#062B5C]">
        {title}
      </div>
      <div className="mt-3 flex flex-col gap-2">{children}</div>
    </div>
  );
}

function FooterLink({ to, children }) {
  return (
    <NavLink to={to} className="text-sm text-[#5B6B82] hover:text-[#062B5C]">
      {children}
    </NavLink>
  );
}
